import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { userInfoQueryOptions } from '@/hooks/users/use-user-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useUpdateNickName() {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, string>({
    mutationKey: ['/UpdateNickName'],
    mutationFn: (params) => fetcher('/UpdateNickName', { NickName: params }, { validResponseCodes: [0] }),
    onSuccess: (_, params) => {
      queryClient.setQueryData(userInfoQueryOptions.queryKey, (data) =>
        produce(data, (draft) => {
          if (!draft) return draft;
          draft.NickName = params;
        }),
      );
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
